module.exports = __webpack_public_path__ + "img/hopital_enseignement_juif.1c9e0732.webp";